module.exports = __webpack_public_path__ + "img/germany-tuberculosis-male.3891ce78.png";